import { Component, EventEmitter, Input, Output } from "@angular/core";

export interface Step {
  active?: boolean;
  disabled?: boolean;
  completed?: boolean;
  label?: string;
  value?: any;
  description?: string;
}

@Component({
  selector: "ta-stepper",
  templateUrl: "./stepper.template.html"
})
export class StepperComponent {
  @Input()
  get steps(): Step[] {
    return this._steps;
  }
  set steps(val: Step[]) {
    this._steps = val;
    this.activeStep = val.findIndex((step) => !!step.active);
  }
  private _steps: Step[] = [];

  @Input()
  get activeStep(): number {
    return this._activeStep;
  }
  set activeStep(val: number) {
    if (val === this._activeStep) {
      return;
    }
    this._activeStep = val;
    this.activeStepChange.emit(this._activeStep);
  }
  private _activeStep: number;

  @Input()
  updateActiveStep = (idx: number) => {
    this.activeStep = idx;
  };

  @Output()
  activeStepChange = new EventEmitter<any>();

  protected setActiveStep(idx: number): void {
    this.updateActiveStep(idx);
  }
}
